import { Group, Text, Tooltip } from '@mantine/core'

import { FaIcon } from '#components/FaIcon'

import styles from './EmptyPageFinder.module.scss'

export const EmptyPageFinder = ({ count }: { count: number }) => {
  if (count === 0) return null

  const label = count > 0 ? 'Empty pages' : 'Empty page'
  return (
    <div className={styles.pagelock_footer}>
      <Group justify="flex-end">
        <Group gap={3}>
          <Tooltip label={label}>
            <FaIcon size="15" icon="fa-circle-exclamation" c="blue.4" />
          </Tooltip>
          <Text size="sm" c="dark">
            {count}
          </Text>
        </Group>
      </Group>
    </div>
  )
}
